import React from 'react'
import styled, { keyframes } from 'styled-components'
import PropTypes from 'prop-types'

const animation = props => keyframes`
  0% {
    transform: translateX(-200px)
  }
  100% {
    transform: translateX(${props.animationWidth}px)
  }
`

const Wrapper = styled.span`
  background-color: #eee;
  background-size: 200px 100%;
  background-repeat: no-repeat;
  display: inline-block;
  line-height: 1;
  width: ${props => (props.width ? props.width : '100%')};
  ${props => props.height && `height: ${props.height};`}
  overflow: hidden;
`

const Glare = styled.span`
  display: inline-block;
  background-image: linear-gradient(
    to right,
    rgba(245, 245, 245, 0) 0%,
    rgba(245, 245, 245, 1) 50%,
    rgba(245, 245, 245, 0) 100%
  );
  background-image: -webkit-linear-gradient(
    left,
    rgba(245, 245, 245, 0) 0%,
    rgba(245, 245, 245, 1) 50%,
    rgba(245, 245, 245, 0) 100%
  );
  animation: ${animation} 1.2s ease-in-out infinite;
  height: 100%;
  width: 200px;
`

const Skeleton = ({ height, width, animationWidth }) => {
  return (
    <Wrapper height={height} width={width}>
      <Glare animationWidth={animationWidth + 200}>&zwnj;</Glare>
    </Wrapper>
  )
}

Skeleton.defaultProps = {
  animationWidth: 100
}

Skeleton.propTypes = {
  height: PropTypes.string,
  animationWidth: PropTypes.number,
  width: PropTypes.string
}

export default Skeleton
